import React from 'react';
import { useInput, FieldTitle } from 'react-admin';
import { CurrencyAutocomplete as DefaultCurrencyAutocomplete } from '~/components';

const CurrencyAutocomplete = ({ source, label, helperText, ...props }: any) => {
  const {
    input: { value, onChange, ...inputProps },
    meta: { touched, error },
    isRequired,
  } = useInput({ source, ...props });

  return (
    <DefaultCurrencyAutocomplete
      source={source}
      label={label !== undefined ? <FieldTitle label={label} source={source} /> : undefined}
      value={value ?? ''}
      onChange={onChange}
      error={!!(touched && error)}
      helperText={touched && error ? error : helperText}
      required={isRequired}
      {...inputProps}
      {...props}
    />
  );
};

export default CurrencyAutocomplete;
